import React from "react";
import { Link } from "react-router-dom";
import {
  Navbar,
  Collapse,
  Nav,
  NavItem,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "reactstrap";



import bedbug from "../assets/images/bedbugGray.png";
import mosquito from "../assets/images/mosquitoGray.png";
import leish from "../assets/images/leishGray.png";
import skin from "../assets/images/skinGray.png";
import pulm from "../assets/images/pulmaoGray.png";
import Logo from "./Logo";
import { ReactComponent as LogoWhite } from "../assets/images/logos/materialprowhite.svg";
import user1 from "../assets/images/users/user4.jpg";

const fontStyle = {
  fontFamily:"gidole",
  color:'#fefefe', 
  fontSize: '130%',

};

const HeaderMenu = () => {
  const [isOpen, setIsOpen] = React.useState(false);

  const [dropdownOpen, setDropdownOpen] = React.useState(false);

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const Handletoggle = () => {
    setIsOpen(!isOpen);
  };
  

  const showMobilemenu = () => {
    document.getElementById("sidebarArea").classList.toggle("showSidebar");
    //alert(document.getElementById("sidebarArea").id);
  };
  return (
    <Navbar color="ciatenhead" dark expand="md" className="fix-header" style={{ height: '40px' }}>
      {/* <div className="d-flex align-items-center">
        <div className="d-lg-block d-none me-5 pe-3">
          <Logo /> 
        </div>
        <NavbarBrand href="/">
        &nbsp;<LogoWhite className=" d-lg-none" />
        </NavbarBrand>
        <p style={fontStyle}>Linhas de Cuidado de Agravos Negligenciados</p>
        
      </div> */}
      <div className="hstack gap-2">
        
        <Button
          color="primary"
          size="sm"
          className="d-sm-block d-md-none"
          onClick={Handletoggle}
        >
          
          {isOpen ? (
            <i className="bi bi-x"></i>
          ) : (
            
            <i className="bi bi-three-dots-vertical"></i>
          )}
        </Button>
      </div>

      <Collapse navbar isOpen={isOpen}>
        
        <Nav className="me-auto" navbar>
          {/* <NavItem>
            <Link to="/starter" className="nav-link" >
              <p style={fontStyle}>Linhas de Cuidado de Agravos Negligenciados</p>
            </Link>
          </NavItem> */}
          
          <NavItem>
            <Link to="/chagas1" className="navee" > 
              <img width="12%" src={bedbug} alt="Bedbug" />
              &nbsp;Doença de Chagas
            </Link>
          </NavItem>

          <NavItem>
            <Link to="/calazar1" className="navee" > 
              <img width="12%" src={mosquito} alt="Bedbug" />
              &nbsp;Calazar
            </Link>
          </NavItem>

          <NavItem>
            <Link to="/Leish1" className="navee" > 
              <img width="12%" src={leish} alt="Bedbug" />
              &nbsp;Leishmaniose
            </Link>
          </NavItem>

          <NavItem>
            <Link to="/hans_Geral" className="navee" > 
              <img width="12%" src={skin} alt="Bedbug" />
              &nbsp;Hanseníase
            </Link>
          </NavItem>

          <NavItem>
            <Link to="/TB_Geral" className="navee" > 
              <img width="6%" src={pulm} alt="Bedbug" />
              &nbsp;Tuberculose
            </Link>
          </NavItem>
          
          

          <Button title="Legendas"
                    color="primary"
                    className=" d-lg-block"
                    onClick={() => showMobilemenu()}
                  >
                    <i className="bi bi-list"></i>
          </Button>

          

          {/* <UncontrolledDropdown >
            <DropdownToggle caret  className="nav-link">
             Hanseníase
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem>Option 1</DropdownItem>
              <DropdownItem>Option 2</DropdownItem>
              <DropdownItem divider />
              <DropdownItem>Reset</DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown> */}


        </Nav>
        
        {/*
         <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle color="transparent">
            <img
              src={user1}
              alt="profile"
              className="rounded-circle"
              width="30"
            ></img>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem header>Info</DropdownItem>
            <DropdownItem>My Account</DropdownItem>
            <DropdownItem>Edit Profile</DropdownItem>
            <DropdownItem divider />
            <DropdownItem>My Balance</DropdownItem>
            <DropdownItem>Inbox</DropdownItem>
            <DropdownItem>Logout</DropdownItem>
          </DropdownMenu>
        </Dropdown> */}
       
      </Collapse>
    </Navbar>
  );
};

export default HeaderMenu;
